import React, { FC } from 'react';
import { View } from 'react-native';
import { DailyDayForecastTile, FocusableFlatList } from '@components';

import { dailyWeatherPageTestIDs, hourlyWeatherPageTestIDs } from '@constants';
import { navigationService } from '@services';
import { DailyForecastData } from '@store';

import { getDayForecasts } from './helpers';
import { styles } from './styles';
import { DayForecast } from './types';

type DailyWeatherBottomRowProps = {
  data: DailyForecastData;
  error: unknown;
  isLoading: boolean;
  focusIndexChanged: (val: number) => void;
  nextFocusUp: unknown;
};

export const DailyWeatherBottomRow: FC<DailyWeatherBottomRowProps> = ({
  data,
  error,
  isLoading,
  focusIndexChanged,
  nextFocusUp,
}) => {
  const testIDS = [
    dailyWeatherPageTestIDs.todayWeatherTile,
    dailyWeatherPageTestIDs.tomorrowWeatherTile,
    dailyWeatherPageTestIDs.dayAfterTomorrowWeatherTile,
    dailyWeatherPageTestIDs.dayThreeWeatherTile,
    dailyWeatherPageTestIDs.dayFourWeatherTile,
    dailyWeatherPageTestIDs.dayFiveWeatherTile,
    dailyWeatherPageTestIDs.daySixWeatherTile,
  ];

  return (
    <View style={styles.bottomRowWrapper}>
      <FocusableFlatList
        data={getDayForecasts(data, isLoading, error)}
        focusIndexChanged={focusIndexChanged}
        horizontal
        keyExtractor={(item: DayForecast, index: number) => String(item.dayIndex ?? index)}
        nextFocusUp={nextFocusUp}
        renderItem={(item: DayForecast, index: number) => (
          <DailyDayForecastTile
            dayName={item.dayName}
            dayTemp={item.dayTemp}
            error={item.error}
            iconCodeExtend={item.iconCodeExtend}
            index={index}
            isLoading={item.isLoading}
            nightTemp={item.nightTemp}
            precipChance={item.precipChance}
            testID={testIDS[index]}
            validTimeUtc={item.validTimeUtc}
            wxPhraseLong={item.wxPhraseLong}
            onPress={() => navigationService.navigate(hourlyWeatherPageTestIDs.hourlyWeatherPage, item)}
          />
        )}
        testID={dailyWeatherPageTestIDs.dailyWeatherTiles}
        wrapItem={false}
      />
    </View>
  );
};
